<template>
  <section>
    <report-filter-bar
      v-model="filter"
      :preset="preset"
      :busy="isAnyLoading"
      :compare-label="compareLabel"
      @preset="applyPreset"
      @change="refresh"
      @refresh="refresh"
    />

    <!-- مبلغ و تعداد روی دو نمودار جدا: یک محور در هر پلات -->
    <b-row class="match-height">
      <b-col
        cols="12"
        class="mb-1"
      >
        <report-chart
          :series="trend"
          title="روند درآمد"
          :subtitle="rangeLabel"
          :metrics="['revenue', 'discount']"
          type="area"
          :height="340"
          :loading="loading('trend')"
          :skin="skin"
        />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        lg="8"
        cols="12"
        class="mb-1"
      >
        <report-chart
          :series="trend"
          title="تعداد سفارش و اقلام"
          :subtitle="rangeLabel"
          :metrics="['orders', 'items', 'customers']"
          type="bar"
          :height="300"
          :loading="loading('trend')"
          :skin="skin"
        />
      </b-col>

      <b-col
        lg="4"
        cols="12"
        class="mb-1"
      >
        <report-chart
          :series="trend"
          title="میانگین ارزش سبد"
          subtitle="نسبت درآمد به تعداد سفارش در هر بازه"
          :metrics="['aov']"
          type="line"
          :height="300"
          :loading="loading('trend')"
          :skin="skin"
        />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        lg="4"
        cols="12"
        class="mb-1"
      >
        <report-funnel
          :steps="funnel"
          :loading="loading('funnel')"
          :skin="skin"
        />
      </b-col>

      <b-col
        lg="4"
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="byBank"
          title="درگاه پرداخت"
          :subtitle="rangeLabel"
          label-title="درگاه"
          :loading="loading('byBank')"
        />
      </b-col>

      <b-col
        lg="4"
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="byStatus"
          title="وضعیت سفارش"
          :subtitle="rangeLabel"
          label-title="وضعیت"
          :loading="loading('byStatus')"
        />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        lg="5"
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="byShipping"
          title="روش ارسال"
          :subtitle="rangeLabel"
          label-title="روش"
          :loading="loading('byShipping')"
        />
      </b-col>

      <b-col
        lg="7"
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="byProvince"
          title="فروش به تفکیک استان"
          subtitle="بر اساس استان ثبت‌شده در آدرس سفارش"
          label-title="استان"
          :loading="loading('byProvince')"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col
        cols="12"
        class="mb-1"
      >
        <report-heatmap
          :cells="heatmap"
          :loading="loading('heatmap')"
          :skin="skin"
        />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import reportMixin from '@core/mixins/report'

export default {
  name: 'ReportSales',
  mixins: [reportMixin],
  data() {
    return {
      trend: null,
      funnel: [],
      byBank: null,
      byStatus: null,
      byShipping: null,
      byProvince: null,
      heatmap: [],
    }
  },
  computed: {
    compareLabel() {
      return this.trend && this.trend.CompareRange ? this.trend.CompareRange.Label : null
    },
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      const api = this.$api.report

      this.fetchReport('trend', api.salesTrend)
      this.fetchReport('byBank', api.salesByBank)
      this.fetchReport('byStatus', api.salesByStatus)
      this.fetchReport('byShipping', api.salesByShipping)
      this.fetchReport('byProvince', api.salesByProvince)
      this.fetchReport('heatmap', api.salesHeatmap)
      this.fetchReport('funnel', api.salesFunnel)
    },
  },
}
</script>
